module.exports = __webpack_public_path__ + "static/img/rule_2.014b05a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/yayaLand/popup/rule_2.png
// module id = kCc3
// module chunks = 1